// extracted by mini-css-extract-plugin
export default {"file-name":"excelFile_file-name__XbfYk"};